import React from 'react'
import { LightboxProvider, useLightboxState } from './LightboxProvider'
import { LocaleProvider, useLocaleState } from './LocaleProvider'
import { PortalProvider, usePortalState } from './PortalProvider'

function ContextProvider({ children }) {
	return (
		<LocaleProvider>
			<PortalProvider>
				<LightboxProvider>{children}</LightboxProvider>
			</PortalProvider>
		</LocaleProvider>
	)
}

export { ContextProvider, useLightboxState, useLocaleState, usePortalState }
